import React, { Component } from 'react';

class PrideApi extends Component {
    render() {
        return (
            <div className="App">
            <a href="http://pr1deflags.herokuapp.com/" target="_blank">
              <h2>Pride Flag API</h2>
            </a>
            <h4>PostgreSQL | Express | React | Node.JS </h4>
            <h5>API and database of 59 pride flag images</h5>
            <h5>
              created and implemented a usable API from scratch, complete with
              developer-friendly instructions and README
            </h5>
            <h5>
              combined research skills, socio-cultual competency with front and
              back end javascript to catalogue queer iconography in an easily
              accessible format
            </h5>
          </div>
            )}
}
export default PrideApi